import React, {useEffect, useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";

import './ChoixPortePage.scss'
import BaseButton from "../../Components/BaseButton/BaseButton";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {DoorModel} from "../../Models/DoorModel";
import {setDoor} from "../../store/actions";
import {useError} from "../../hooks/useError";
import {useGetEvent} from "../../hooks/useGetEvent";
import Error from "../../Components/Error/Error";
import {useTranslation} from "react-i18next";

const ChoixPortePage: React.FC = ({}) => {
    const {t} = useTranslation(['choixPorte', 'common'])
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const doors = useSelector<StateModel, DoorModel[]>(state => state.stadium?.doors || [])
    const eventError = useError()
    const apiError = useError()
    const getEvent = useGetEvent(() => eventError.open(""), () => apiError.open(""))

    const [searchParams,] = useSearchParams();
    const stadium = searchParams.get("stadium") ?? undefined;

    const [choice, setChoice] = useState<string | null>(null)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        getEvent(stadium)
    }, [stadium])

    const submit = () => {
        const door = doors.find(d => d.name.toLowerCase() === choice?.toLowerCase())
        if(!door) {
            setError(stadium === "BMA" ? t('errors.blockNotFound', {choice}) : t('errors.doorNotFound', {choice}))
        } else {
            setError(null)
            dispatch(setDoor(door))
            navigate(`/stands?stadium=${searchParams.get("stadium")}&doorId=${door.id}`)
        }
    }

    return (
        <BasePage showLogo showHistorique showPanier>
            <p className="choixPortePageText">{stadium === "BMA" ? t('instructionsBlock') : t('instructionsDoor')}</p>
            <p className="choixPortePageSubText">{stadium === "BMA" ? t('helpBlock') : t('helpDoor')}</p>
            <div className="choixPortePageTextInputContainer">
                <input className="choixPortePageInput" placeholder={t('placeholder')} onKeyUp={(e: any) => setChoice(e.target.value)}/>
                <small className="choixPortePageError">{error}</small>
            </div>
            <BaseButton onClick={submit} text={t('common:actions.validate')} className="choixPortePageBtn" disabled={!choice}/>
            <Error show={eventError.visible} title={t('common:errors.noEvent.title')} subTitle={t('common:errors.noEvent.subtitle')} />
            <Error show={apiError.visible} title={t('common:errors.serviceUnavailable.title')} subTitle={t('common:errors.serviceUnavailable.subtitle')} />
        </BasePage>
    )
}

export default ChoixPortePage;
